import React from "react";
import "./CrashSessionCard.css";
import SkeletonLoader from "components/SkeletonLoader/SkeletonLoader";

interface CrashSessionCardProps {
  title?: string;
  metaData?: {label:string,value:string};
  percentage?: string;
  loading?: boolean;
  children?:React.ReactElement
}

const CrashSessionCard: React.FC<CrashSessionCardProps> = ({
  title,
  percentage,
  metaData,
  loading,
  children
}) => {
  return (
    <div className="crash-session-card-main-container">
      {!loading ?children?children: (
        <>
          <div className="card-title">{title}</div>
          <div className="d-flex justify-content-between"><span className="card-value">{percentage}</span>{metaData?.value && <span className="mt-auto d-flex gap-2"><span>{metaData?.label}:</span><span className="card-subvalue">{metaData?.value}</span></span>}</div>
        </>
      ) : (
        <SkeletonLoader type="default" />
      )}
    </div>
  );
};

export default CrashSessionCard;
